import './polyfill/index'
import React from 'react'
import { render } from 'react-dom'
import 'babel-polyfill' // for ie

import { getLocale } from './util/Localizer'
import { isBrowserSupported } from './util/BrowserInfo'

import { trackTrace } from './util/analytics/ApplicationInsights'

import Config from './Config'
import vi from './versionInfo'
import { PwaRefreshStyles } from './theme'

import './css/styles.css'

import Root from './root'

import registerServiceWorker, { ServiceWorkerStatus } from './registerServiceWorker'

import Button from '@material-ui/core/Button'

let local = getLocale()
// Check to see if we support this browser
if (
  window.location.pathname.indexOf('NotSupported') === -1 &&
  !isBrowserSupported()
) {
  if (local === 'en') {
    window.location = '/notSupported.html'
  } else {
    window.location = '/notSupportedFr.html'
  }
}

// output us
console.log('built by:')
console.log('%c              %                                                                                                                  ', 'color: #d42127; font-weight: bold;')
console.log('%c           #######                                                                                                               ', 'color: #d42127; font-weight: bold;')
console.log('%c        #####   #####%                                                                                                           ', 'color: #d42127; font-weight: bold;')
console.log('%c    #####           #####                                                                                                        ', 'color: #d42127; font-weight: bold;')
console.log('%c #####        &        #####         ########          #########        #########          ########          ##       ###########', 'color: #d42127; font-weight: bold;')
console.log('%c #####     #######     #####         ##     ###        ##               #        ##        ##     ##         ##            ##    ', 'color: #d42127; font-weight: bold;')
console.log('%c ###        #####        ###         ##      ##        ##               #         ##       ##     ##         ##            ##    ', 'color: #d42127; font-weight: bold;')
console.log('%c ###    ##         ##    ###         ##    ###         #########        #          ##      ##   %##          ##            ##    ', 'color: #d42127; font-weight: bold;')
console.log('%c ###    #####   #####    ###         ## ##             ##               #          ##      ##     ##         ##            ##    ', 'color: #d42127; font-weight: bold;')
console.log('%c ###    #####   #####    ###         ##  ###           ##               #         ###      ##      ##        ##            ##    ', 'color: #d42127; font-weight: bold;')
console.log('%c ###       ##   ##       ###         ##    ##          ##               #        ###       ##      ##        ##            ##    ', 'color: #d42127; font-weight: bold;')
console.log('%c ####%                 @####         ##     ###        #########        #########          #########         ##            ##    ', 'color: #d42127; font-weight: bold;')
console.log('%c    #####           #####                                                                                                        ', 'color: #d42127; font-weight: bold;')
console.log('%c       #####  ## #####                                                                                                           ', 'color: #d42127; font-weight: bold;')
console.log('%c           #######                                                                                                               ', 'color: #d42127; font-weight: bold;')

// set the window title from config
window.document.title = Config.title

// hack - this is so we can continue to use console.log and don't have to worry abotu it in production.
// we should probably abstract this out to a seperate helper class
const log = console.log
const warn = console.warn

console.log = function () {
  if (Config.debugMode) {
    log.apply(this, arguments)
  }
  // send to app insights
  // NOTE: assumes the first param is a string, need to implement something like
  // https://developers.google.com/web/tools/chrome-devtools/console/console-write#string_substitution_and_formatting
  // or
  // https://developers.google.com/web/tools/chrome-devtools/console/console-reference#warn where you can send multiple param
  if (typeof arguments[0] === 'string') {
    trackTrace(arguments[0], null, 1 /* 1 = Information */)
  }
}
console.warn = function () {
  if (Config.debugMode) {
    warn.apply(this, arguments)
  }
  // send to app insights
  // NOTE: see note above in log method
  if (typeof arguments[0] === 'string') {
    trackTrace(arguments[0], null, 2 /* 1 = Warning */)
  }
}

// output version info to the console
console.info(
  `%c ${Config.title} v.${vi} (API: ${Config.apiUrl})`,
  'color: #AB0634; font-weight: bold;'
)
console.log(
  `%c React Version ${React.version}`,
  'color: #61dafb; font-weight: bold;'
)

render(<Root />, document.querySelector('#root'))

// register the service worker for working in offline

const dispatchUpdateNotification = function () {
  const event = new CustomEvent('root.openSnackbar', {
    detail: {
      props: {
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'bottom'
        }
      },
      contentProps: {
        message: 'A new version of this app is available.\nPlease refresh the page to update.',
        action: (
          <Button style={PwaRefreshStyles} onClick={() => window.location.reload()}>
            Refresh
          </Button>
        ),
        classes: {
          message: 'multiline-snackbar-message'
        }
      }
    }
  })

  window.dispatchEvent(event)
}

registerServiceWorker(({ status }) => {
  switch (status) {
    case ServiceWorkerStatus.updated:
      dispatchUpdateNotification()
      break
    default:
      break
  }
}, error => {
  console.warn('Error during service worker registration:', error)
})



// WEBPACK FOOTER //
// ./src/index.js